import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getFirstAnalyses = asyncThunkWrapper({ 
  model: 'firstAnalyses', 
  action: 'getFirstAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'input', 'status', 'updated_at']
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/first_flow/first_analyses', { params });

    return response.data;
  } 
});
export const getFirstAnalysis = asyncThunkWrapper({ 
  model: 'firstAnalyses', 
  action: 'getFirstAnalysis', 
  func: async ({ id, cable = false }) => {
    const params = { attributes: ['id', 'input', 'result', 'status', 'updated_at'] };
    const response = await axios.get(`/first_analyses/${id}`, { params });
      
    return { data: response.data, cable };
  } 
});
export const clearLocalFirstAnalyses = createAction('firstAnalyses/clearLocalFirstAnalyses');
export const clearLocalActiveFirstAnalysis = createAction('firstAnalyses/clearLocalActiveFirstAnalysis');